
import { Dropdown, Menu, MenuItem } from 'ant-design-vue';
import { CaretDownOutlined } from '@ant-design/icons-vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {
    ADropdown: Dropdown,
    AMenu: Menu,
    AMenuItem: MenuItem,
    CaretDownOutlined
  },
  props: ['pamirsPartner', 'pamirsPartnerList', 'onUserChange']
});
